module.exports = __webpack_public_path__ + "img/7.8c162c1b.jpg";